export default {"src":"/_next/static/media/google-login.3454f69f.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};